import { Device } from 'DeviceUtils';
import { title } from 'process';
import { StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';

let baseStyles = {
    headerIconContainer: {
        backgroundColor: 'black',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    backIcon: {
        width: 29,
        height: 29,
        color: Theme.primaryTextColor
    },
    mainContainer: {
        flex: 1,
        justifyContent: 'center',
        alignSelf: 'center',
        height: '100vh',
        marginTop: Device.isPhone ? '30%' : null,
        maxWidth: Device.isTablet ? null : 300,
        top: Device.isPhone ? '-10%' : null
    },
    contentContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        top: Device.isTablet ? '20%' : null,
        maxWidth: 350,
        height: '100vh',
        marginBottom: Device.isTablet ? null : 14,
        margin: Device.isTablet ? 'auto' : null
    },
    title: {
        ...fontStyles.title,
        color: Theme.primaryTextColor,
        marginBottom: 10,
        marginTop: 10,
        fontSize: 25,
        textAlign: 'center'
    },
    content: {
        ...fontStyles.subtitle,
        color: Theme.primaryTextColor,
        marginBottom: 25,
        marginTop: 25,
        textAlign: 'center'
    },
    pressableContainer: {
        flexDirection: 'row',
        gap: 14
    },
    pressable: {
        backgroundColor: '#FFFFFF',
        borderRadius: 12,
        width: 144,
        height: 144,
        zIndex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    icon: {
        zIndex: 4,
        width: 37,
        height: 48,
        color: Theme.primaryTextColor,
        top: 27,
        marginBottom: 15
    },
    buttonTitle: {
        color: Theme.primaryTextColor,
        marginTop: 10,
        fontSize: 18,
        zIndex: 2,
        maxWidth: 144
    },
    button: {
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 14,
        marginHorizontal: 'auto',
        width: Device.isTablet ? 300 : '100%'
    }
};

export default StyleSheet.create(baseStyles);
